import { render, staticRenderFns } from "./MessagesList.vue?vue&type=template&id=05a3f9b9&scoped=true&"
import script from "./MessagesList.vue?vue&type=script&lang=js&"
export * from "./MessagesList.vue?vue&type=script&lang=js&"
import style0 from "./MessagesList.vue?vue&type=style&index=0&id=05a3f9b9&prod&lang=less&"
import style1 from "./MessagesList.vue?vue&type=style&index=1&id=05a3f9b9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a3f9b9",
  null
  
)

export default component.exports